function MenuHandler(product = '', event = '', data = {}) {

    const { metaData = {}, url = '' } = data,
        { userId, name = '', email = '', mobile = '', balance = 0 } = metaData;

    let finalData = {
        userId: userId, userName: name, userEmail: email, userContact: mobile, walletBalance: balance, urlPath: url, product: product
    }

    switch (event) {
        case 'PageView':
            break;
        case 'Flight':
            break;
        case 'Hotel':
            break;
        case 'Rail':
            break;
        case 'Dashboard':
            break;
        case 'Maldives Package':
            break;
        case 'Visa':
            break;
        case 'Insurance':
            break;
        case 'Top Up':
            break;
    }
    return finalData;
}

module.exports = { MenuHandler }